<template>
  <div class="footer">
    <div class="footer-content" v-if="location">
      <div id="openinghours">
        <div class="title">Öffnungszeiten</div>
        <OpeningHours />
      </div>

      <div id="notice" v-if="location.notice">
        <notice :text="location.notice" />
      </div>

      <div id="reservations">
        <div class="title">Reservierungen</div>
        <div class="inline">
          <div class="table">
            <div class="table-row" v-if="location.address">
              <div class="table-cell text-right pr-1">
                <font-awesome-icon :icon="['fal', 'map-marked']" />
              </div>
              <div class="table-cell text-left p-2 pre">{{ location.address }}</div>
            </div>

            <div class="table-row link" v-if="location.phone">
              <div class="table-cell text-right pr-1">
                <a :href="'tel:' + location.phone.replace(' ', '')"><font-awesome-icon :icon="['fal', 'phone']" /></a>
              </div>
              <div class="table-cell text-left p-2">
                <a :href="'tel:' + location.phone.replace(' ', '')">{{ location.phone }}</a>
              </div>
            </div>

            <div class="table-row link" v-if="location.mail">
              <div class="table-cell text-right pr-1">
                <a :href="'mailto:' + location.mail"><font-awesome-icon :icon="['fal', 'envelope']" /></a>
              </div>
              <div class="table-cell text-left p-2">
                <a :href="'mailto:' + location.mail">{{ location.mail }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <signature />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import OpeningHours from '@/components/OpeningHours'
import signature from '@/components/signature'
import notice from '@/components/notice'

export default {
  name: 'Footer',
  components: { OpeningHours, signature, notice },
  asyncComputed: {
    ...mapState(['location']),
  },
  data: function () {
    return {
    }
  },
  methods: {
    goto(route) {
      // console.log(route)
      this.$router.push(route)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/style/settings.scss";

.footer {
  font-size: small;
  background-color: rgba(0,0,0,.5);
  .footer-content {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    align-items: stretch;
    text-align: left;

    @media (max-width: $media-s) {
      flex-direction: column;
    }

    > * {
      margin: $spacing;
      padding: $spacing;
    }

    .title {
      text-transform: uppercase;
      font-weight: 600;
      font-size: 1.4em;
      text-align: center;
      margin-bottom: $spacing * .6;
    }
    #reservations {
      text-align:center;
      .inline {
        display: inline-block;
        text-align: left;
      }
      .table-cell {
        padding: $spacing / 2;
      }
    }
  }
  .signature {
    text-align: right;
    display:block;
    // width:100%;
    padding: 0 $spacing $spacing $spacing;
  }
}
</style>
